import { createFileRoute } from '@tanstack/react-router';
import { MapPin, Mail, Phone } from 'lucide-react';

export const Route = createFileRoute('/contact')({
  component: ContactPage,
});

function ContactPage() {
  return (
    <div>
      <div className='container mx-auto px-4 py-8 max-w-4xl'>
        <h1 className='text-3xl font-bold text-foreground mb-4'>Contact Us</h1>

        {/* Contact Information Container */}
        <div className='mx-auto max-w-2xl'>
          {/* Content */}
          <div className='rounded-xl bg-background border border-border p-8 space-y-6'>
            <div className='flex items-start space-x-4'>
              <div className='flex-shrink-0 mt-1'>
                <MapPin className='h-6 w-6 text-primary' />
              </div>
              <div>
                <h3 className='font-semibold text-foreground mb-2'>Address</h3>
                <div className='text-muted-foreground'>
                  <a
                    href='https://maps.google.com/?q=351+W+Opportunity+Way,+Suite+440,+Draper,+UT+84020'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='hover:text-primary hover:underline transition-colors cursor-pointer'
                  >
                    <p>351 W Opportunity Way, Suite 440</p>
                    <p>Draper, UT 84020</p>
                  </a>
                </div>
              </div>
            </div>

            <div className='flex items-start space-x-4'>
              <div className='flex-shrink-0 mt-1'>
                <Mail className='h-6 w-6 text-primary' />
              </div>
              <div>
                <h3 className='font-semibold text-foreground mb-2'>Email</h3>
                <a
                  href='mailto:accountdept@landcar.com'
                  className='text-primary hover:text-accent hover:underline transition-colors font-medium'
                >
                  accountdept@landcar.com
                </a>
              </div>
            </div>

            <div className='flex items-start space-x-4'>
              <div className='flex-shrink-0 mt-1'>
                <Phone className='h-6 w-6 text-primary' />
              </div>
              <div>
                <h3 className='font-semibold text-foreground mb-2'>Phone</h3>
                <a
                  href='tel:800-733-7339'
                  className='text-primary hover:text-accent hover:underline transition-colors font-medium'
                >
                  (800) 733-7339
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
